import EmptyState from 'src/components/ui/EmptyState'
import { CircleEmptyGalleryIcon } from 'src/components/ui/Icons/CircleEmptyGalleryIcon'

function EmptyGallery() {
  return (
    <EmptyState variant="rounded">
      <header data-fs-empty-state-title>
        <CircleEmptyGalleryIcon width="40.5" height="40.5" />
        <p>Nada coincide con tu búsqueda.</p>
      </header>
    </EmptyState>
  )
}

export default EmptyGallery
